import React from 'react'
import { ArrowLeft } from 'react-feather';
import Select from "react-select";
import PartnerListTable from './PartnerListTable';

const AssociatePartner = (props) => {
    return (
        <div>
            <label>
                <b>Associate Partner with Service</b>
            </label>
            <div className="row mt-2">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Select Service <span className="required">*</span></label><br />
                    <Select
                        options={props.serviceOptions}
                        onChange={props.onServiceNameChange}
                        value={props.selectedServiceNames}
                        placeholder="Select Service"
                    />
                </div>
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Partner List <span className="required">*</span></label><br />
                    <Select
                        options={props.servicePartnerOptions}
                        onChange={props.onServicePartnerNameChange}
                        value={props.selectedServicePartnerNames}
                        placeholder="Select Service Partner"
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col">
                    <button className='my-services-model-submit-btn' onClick={props.associateButton}>Associate Partner</button>
                    <button className='my-services-model-submit-btn ml-2' onClick={props.clearBtn}>Clear</button>
                    <button className='my-services-model-submit-btn float-right' onClick={props.newPartnerButton}>Add New Partner</button>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12">
                    <PartnerListTable
                        serviceList={props.serviceList}
                        partnerList={props.partnerList}
                        handleDisassociateBtnClick={props.handleDisassociateBtnClick}
                        selectedServiceNames={props.selectedServiceNames}
                        getTableData={props.getTableData} />
                </div>
            </div>


        </div>
    )
}

export default AssociatePartner
